const SecutiryType = {
    UPDATE_PRODUCTS: "UPDATE_PRODUCTS",
    UPDATE_USER : "UPDATE_USER"
    
}

export default SecutiryType;